export default {
    parent: 'SurveyLayout',
    url: '/survey',
    template: '<ui-view></ui-view>',
    abstract: true,
    resolve: {
        bootstrap (TranslationService) {
            return TranslationService.changeLanguage();
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/states/survey/index.js